import { Icon } from "@iconify/react";
import { useEffect, useRef, useState } from "react";
import personFill from "@iconify/icons-eva/person-fill";
import { useLocation, useNavigate } from "react-router-dom";
import { get_root_value } from "src/utils/domUtils";
import unlockFill from "@iconify/icons-eva/unlock-fill";
import { alpha } from "@mui/material/styles";
import {
  Button,
  Box,
  Divider,
  MenuItem,
  Typography,
  Avatar,
  IconButton,
} from "@mui/material";
import MenuPopover from "../../components/MenuPopover";
import { s3baseUrl } from "src/config/config";
import { usePGIMode } from "src/Hooks/PGIModeContext";
import ChangePassword from "src/components/_dashboard/ChangePassword";
import { defaultSettingApi } from "src/DAL/SiteSetting/siteSetting";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import { useChat } from "src/Hooks/ChatContext";

const MENU_OPTIONS = [
  {
    label: "Edit Profile",
    icon: personFill,
    linkTo: "/profile",
  },
];

const handle_embed_tinymce_key = (key) => {
  var head = document.head;
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = `https://cdn.tiny.cloud/1/${key}/tinymce/5/tinymce.min.js`;
  head.appendChild(script);
};

export default function AccountPopover() {
  const { profileNewImage } = usePGIMode();
  const {
    STOP_SOCKET_FORCEFULLY,
    handleUnreadMessageCount,
    handleGoogleId,
    handleSetUserInfo,
    handlesetTinyKey,
  } = useContentSetting();
  const { handleCloseChat } = useChat();
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [profileImage, setProfileImage] = useState(profileNewImage);
  const [openPasswordModal, setopenPasswordModal] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleProfile = (value) => {
    navigate(value);
    handleClose();
  };

  const handleLogout = async () => {
    handleUnreadMessageCount(0);
    handleCloseChat();
    localStorage.clear();
    navigate("/login");
    STOP_SOCKET_FORCEFULLY();
  };

  const getDefaultSetting = async () => {
    const result = await defaultSettingApi();
    if (result.code === 200) {
      if (result.site_setting) {
        handleGoogleId(result.site_setting);
      }
      handlesetTinyKey(result?.default_setting?.tinymce_key);
      handle_embed_tinymce_key(result?.default_setting?.tinymce_key);
      localStorage.setItem(`user_data`, JSON.stringify(result.adminUser));
      handleSetUserInfo(result.adminUser);
      localStorage.setItem("adminLogo", result?.default_setting?.admin_logo);
      localStorage.setItem("favIcon", result?.default_setting?.admin_favicon);
      localStorage.setItem("metaTitle", result.default_setting.meta_title);
      localStorage.setItem(
        "metaDescription",
        result.default_setting.meta_description,
      );
    }
  };

  useEffect(() => {
    getDefaultSetting();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const is_path_includes = (path) => {
        return pathname.toString().includes(path);
      };
      if (!is_path_includes("/form-list")) {
        localStorage.removeItem("UserFormSListSearch");
      }
      if (!is_path_includes("/form-list/forms")) {
        localStorage.removeItem("userFormFilter");
      }
      if (!is_path_includes("/programmes/programmes-form/")) {
        localStorage.removeItem("program_user_form_search");
      }
      if (!is_path_includes("/mindset_type")) {
        localStorage.removeItem("mindset_type");
      }
      if (!is_path_includes("/nutrition_type")) {
        localStorage.removeItem("nutrition_type");
      }
      if (!is_path_includes("/video_type")) {
        localStorage.removeItem("video_type");
      }
      if (!is_path_includes("/exercises_type")) {
        localStorage.removeItem("exercises_type");
      }
      if (!is_path_includes("/payment-transactions")) {
        localStorage.removeItem("TransactionListSearch");
      }
      if (!is_path_includes("/member")) {
        localStorage.removeItem("MemberListSearch");
      }
      if (!is_path_includes("/exercise")) {
        localStorage.removeItem("ExercisesListSearch");
      }
      if (!is_path_includes("/subscription-list")) {
        localStorage.removeItem("subscription_list_data");
      }
      if (!is_path_includes("/workout")) {
        localStorage.removeItem("WorkoutListSearch");
      }
      if (!is_path_includes("/support-ticket")) {
        localStorage.removeItem("support_tickets_data");
      }
      if (!is_path_includes("/member")) {
        localStorage.removeItem("day_calories");
      }
      if (!is_path_includes("/nutrition_library")) {
        localStorage.removeItem("nutrition_library_filter");
      }
      if (!is_path_includes("/workout_library")) {
        localStorage.removeItem("workout_library_filter");
      }
      if (!is_path_includes("/mindset_library")) {
        localStorage.removeItem("mindset_library_filter");
      }
      if (!is_path_includes("/video_library")) {
        localStorage.removeItem("video_library_filter");
      }
      if (!is_path_includes("/workbook_library")) {
        localStorage.removeItem("workbook_library_filter");
      }
    }, 100);
  }, [pathname]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setProfileImage(profileNewImage);
    }, 1000);
    return () => clearTimeout(timer);
  }, [profileNewImage]);

  return (
    <>
      <ChangePassword
        openPasswordModal={openPasswordModal}
        setopenPasswordModal={setopenPasswordModal}
      />
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
          }),
        }}
      >
        <Avatar src={s3baseUrl + profileImage} alt="photoURL" />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {localStorage.getItem("name")}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {localStorage.getItem("email")}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => handleProfile(option.linkTo)}
            sx={{ typography: "body2", py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24,
              }}
            />

            {option.label}
          </MenuItem>
        ))}
        <MenuItem
          key=""
          onClick={() => {
            handleClose();
            setopenPasswordModal(true);
          }}
          sx={{ typography: "body2", py: 1, px: 2.5 }}
        >
          <Box
            component={Icon}
            icon={unlockFill}
            sx={{
              mr: 2,
              width: 24,
              height: 24,
              color: get_root_value("--portal-theme-primary"),
            }}
          />
          Change Password
        </MenuItem>
        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={() => handleLogout()}
          >
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
